import React, { Fragment, useEffect } from 'react'
import PropTypes from 'prop-types'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import resizer from '../resizer'

import './Slider.scss'

const Slider = ({ children, className, type, page, direction, rvh }) => {
  useEffect(() => {
    if (document.body.style.maxHeight !== `${rvh}px`) {
      document.body.style.maxHeight = `${rvh}px`
    }
  })

  return (
    <Fragment>
      <TransitionGroup className={`slider-container ${className} ${type}`}>
        <CSSTransition
          key={page}
          classNames={`slider-${direction}`}
          timeout={500}
        >{children}</CSSTransition>
      </TransitionGroup>
    </Fragment>
  )
}


Slider.defaultProps = {
  direction: 'next',
  className: '',
  type: '',
}

Slider.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  type: PropTypes.string,
  page: PropTypes.number.isRequired,
  direction: PropTypes.string,
  rvh: PropTypes.number
}

export default resizer(Slider)
